import { of } from 'rxjs';
import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { map, catchError, exhaustMap, tap } from 'rxjs/operators';
import { ActionTypes } from '@appStore/account/actions';
import * as actions from '@appStore/account/actions';
import { UserNotificationSettingsService } from '@appStore/account/services/user-notification-settings.service';
import { Router } from '@angular/router';

@Injectable()
export class UserNotificationSettingsEffects {
  constructor(
    private router: Router,
    private userNotificationSettingsService: UserNotificationSettingsService,
    private actions$: Actions
  ) {}

  loadUserNotificationChannels$ = createEffect(() => {
    return   this.actions$.pipe(
      ofType(ActionTypes.UserNotificationChannelsLoadData),
      exhaustMap(action => {
        return this.userNotificationSettingsService.GetMyNotificationChannels().pipe(
          map(notificationChannels => new actions.UserNotificationChannelsLoadSuccess(notificationChannels)),
          catchError(error => of(new actions.UserNotificationChannelsLoadFail(error)))
        );
      })
    );
  });
  
  updateUserNotificationChannels$ = createEffect(() => {
    return   this.actions$.pipe(
      ofType(ActionTypes.UserNotificationChannelUpdateItems),
      map((action: actions.UserNotificationChannelsUpdate) => action.payload),
      exhaustMap(notificationChannels => {
        return this.userNotificationSettingsService.UpdateMyNotificationChannels(notificationChannels).pipe(
          map(updatedItems => new actions.UserNotificationChannelsUpdateSuccess(updatedItems)),
          catchError(error => of(new actions.UserNotificationChannelsUpdateFail(error)))
        );
      })
    );
  });

  updateUserNotificationChannel$ = createEffect(() => {
    return   this.actions$.pipe(
      ofType(ActionTypes.UserNotificationChannelUpdateItem),
      map((action: actions.UserNotificationChannelUpdate) => action.payload),
      exhaustMap(notificationChannel => {
        return this.userNotificationSettingsService.UpdateMyNotificationChannel(notificationChannel).pipe(
          map(updatedItem => new actions.UserNotificationChannelUpdateSuccess(updatedItem)),
          catchError(error => of(new actions.UserNotificationChannelUpdateFail(error)))
        );
      })
    );
  });
  
  handleUserNotificationChannelsSuccess$ = createEffect(() =>
    this.actions$.pipe(
      ofType(ActionTypes.UserNotificationChannelUpdateItemsSuccess),
      tap(() => this.router.navigate([`/secure/dashboard`]))
    ),
    { dispatch: false }
  );

}
